import api from 'data/api';

export const updatePreset = api('PUT /api/user/presets/:id');
